import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/persons/actions';
import RaisedButton from 'material-ui/RaisedButton';
import { Page, PageSection, PageBlock, RightDrawer } from 'components/Page';
import ButtonAsync from 'components/Buttons/ButtonAsync';

import Subheader from 'material-ui/Subheader';
import Row from 'components/Form/Row';
import MenuLink  from 'components/Navigation/MenuLink';
import ImageField  from 'components/Form/ImageField';

import Field from 'components/Form/Field';

class Person extends Component {
  state = { };

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/persons");
  }


  componentWillMount() {
    this.props.fetchPerson(this.props.params.id);//(this.props.params.id);
  }

  handleFormSubmit(event) {
    

    var data = _.map(this.refs, (r,i) => { return {[i]: r.state.value || ""} });
    let merged = Object.assign(...data);

    merged.avatarUrl = this.refs.avatar.state.url || "";
    merged.avatarsmallUrl = this.refs.avatarsmall.state.url || "";

    this.props.updatePerson(this.props.params.id, merged);
  }
  renderForm() {
    return (
    <div onSubmit={this.handleFormSubmit.bind(this)} className="form-inline">
          <PageSection label="Översikt">
            <Row>
              <Field ref="name" value={this.props.person.name} floatingLabelText="Namn"/>
            </Row>
            <Row>
              <Field ref="url" value={this.props.person.url} floatingLabelText="Hemsida / URL"/>
            </Row>
            <Row>
              <Field multiLine={true} ref="description" value={this.props.person.description} floatingLabelText="Beskrivning"/>
            </Row>
          </PageSection>
          <PageSection label="Bilder">
            <Row styleName="padded">
              <ImageField ref="avatarsmall" value={this.props.person.avatarsmall} url={this.props.person.avatarsmallUrl} label="Avatar, png 60 x 60"  />
            </Row>
            <Row styleName="padded">
              <ImageField ref="avatar" value={this.props.person.avatar} url={this.props.person.avatarUrl} label="Avatar, png 400 x 400" />
            </Row>
            <Row styleName="padded">
              <ButtonAsync disabled={this.props.pending} onTouchTap={this.handleFormSubmit.bind(this)}  primary={true} label="Spara" />
              <RaisedButton onTouchTap={this.handleCancel.bind(this)} label="Stäng" />
            </Row>
          </PageSection>
        </div>
        )
  }
  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Personer" />
      </RightDrawer>,
      <Page key="page"  ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Person" to="/admin/persons"/>
          <span className="pathsep"></span>
          <MenuLink label={this.props.person.name} to={this.props.params.id}/>
        </Subheader>
        {!this.props.pending && this.renderForm() }
      </Page>
    ]
  }
}

function mapStateToProps(state, ownProps) {
  return { 
    person: state.persons.details.data,
    pending: state.persons.details.pending
  };
}

export default connect(mapStateToProps, actions)(Person)

  



// WEBPACK FOOTER //
// ./src/pages/admin/persons/Person.jsx